import React, { useState, Fragment } from "react";

const TextArea = ({ id, name, rows, className, resize, placeholder, handleChange }) => {
  return (
    <textarea
      id={id}
      name={name}
      rows={rows}
      className={`block w-800 h-40 rounded-xl border-slate-200 focus:border-logo-green focus:ring-logo-green  sm:text-sm ${className}`}
      style={{ resize: resize }}
      placeholder={placeholder}
      onChange={handleChange}
    />
  );
};
export default TextArea;
